<template>
  <b-container fluid>
    <b-card
      class="m-4"
      header="Lista de tipos de escala"
      header-text-variant="white"
      header-tag="header"
      header-bg-variant="success"
      footer-tag="footer"
    >
      <b-card-text>
        <b-row class="mb-3">
          <b-col>
            Filtro
            <b-form-input v-model="filtro"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-table
              id="tabelaPlantoes"
              :items="myProvider"
              :per-page="perPage"
              :current-page="currentPage"
              :fields="campos_tabela"
              :filter="filtro"
              small
            >
              <template v-slot:cell(acoes)="row">
                <!-- `data.value` is the value after formatted by the Formatter -->
                <b-row align-h="end" class="mr-1">
                  <!-- <b-button size="sm" variant="primary" @click="exibeEscala(row.item.id)">
                    <b-icon icon="search"></b-icon>
                  </b-button>-->

                  <b-button
                    v-if="hasPermission('editarTipoDeEscala')"
                    size="sm"
                    class="ml-2"
                    variant="warning"
                    :to="`/tiposdeescala/editar/${row.item.id}`"
                    v-b-tooltip.hover
                    title="Editar"
                  >
                    <b-icon icon="pencil"></b-icon>
                  </b-button>
                </b-row>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="d-flex justify-content-center">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              size="sm"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-card-text>
      <template v-slot:footer>
        <b-button
          variant="success"
          to="tiposdeescala/adicionar"
          v-if="hasPermission('cadastrarTipoDeEscala')"
        >Novo</b-button>
      </template>
    </b-card>
  </b-container>
</template>

<script>
import mixinToast from "@/mixins/mixinToast.js";
import permissionsMixin from "@/mixins/permissionsMixin.js";

export default {
  mixins: [mixinToast, permissionsMixin],
  data() {
    return {
      filtro: "",
      escala: null,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      campos_tabela: [
        { key: "id", label: "ID" },
        { key: "descricao", label: "Descrição" },
        { key: "acoes", label: "Ações", thClass: "cabecalho-direita" }
      ]
    };
  },
  methods: {
    myProvider(ctx) {
      return this.$http
        .get(
          "/tiposdeescala?page=" +
            ctx.currentPage +
            "&limit=" +
            ctx.perPage +
            "&filter=" +
            ctx.filter
        )
        .then(result => {
          this.totalRows = result.data.totalRows;
          return result.data.dados;
        });
    }
  }
};
</script>

<style>
.cabecalho-direita {
  text-align: right;
  padding-right: 0.9rem !important;
}
/* .modal {
  padding: 0 !important;
}
.modal .modal-dialog {
  width: 100%;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal .modal-body {
  overflow-y: auto;
} */
</style>